import { fetchGSASearchResults, generateFetchParams } from "~/GearboxSelectionAssistant/fetchGSASearchResults";
import { useEffect, useRef, useState } from "react";
import { ACTIONS, type useGearboxSALogic } from "~/GearboxSelectionAssistant/useGearboxSALogic";
import { addBaseProductDataAction } from "~/redux/products/actions";
import { useDispatch } from "react-redux";
import { transformSrpProduct } from "~/Search/transformers/transformSrpProduct";
import { useOnMount } from "~/common/hooks/useOnMount";
import { loadCartAmounts } from "~/AddToCart/redux/cartAmounts/actions";

export function useFetchGearboxSAData(
  state: ReturnType<typeof useGearboxSALogic>[0],
  dispatch: ReturnType<typeof useGearboxSALogic>[1],
  ignoreFirstTime: boolean = false
) {
  const [ranOnce, setRanOnce] = useState(false);
  const fetchParams = generateFetchParams(state);
  const abortController = useRef<AbortController>();

  const reduxDispatch = useDispatch();

  useOnMount(() => {
    reduxDispatch(loadCartAmounts());
  });

  useEffect(() => {
    (async () => {
      if (!state.pageSize) {
        // Don't fetch if we don't have a page size calculated yet
        return;
      }
      if (ignoreFirstTime && !ranOnce) {
        setRanOnce(true);
      } else {
        dispatch(ACTIONS.searchStart(state.currentPage > 0 ? "loadingMore" : "searching"));
        abortController.current?.abort();
        try {
          const controller = new AbortController();
          abortController.current = controller;
          const data = await fetchGSASearchResults(fetchParams, controller.signal);
          const products = data.results.map(transformSrpProduct);
          reduxDispatch(addBaseProductDataAction(products));
          dispatch(ACTIONS.searchSuccess(data));
        } catch (e) {
          dispatch(ACTIONS.searchError());
        }
      }
    })();
  }, [fetchParams.toString()]);
}
